export default "__VITE_ASSET__JOJ7LeZi__"